import { Module } from 'vuex';
import { IRootState } from '../root-state.store';
import { ISearchState, SearchState } from './search-state.store';
import { mutations } from './search-mutations.store';
import { actions } from './search-actions.store';
import { getters } from './search-getters.store';

export const searchModule: Module<IRootState, ISearchState> = {
  namespaced: true,
  state: new SearchState(),
  mutations: mutations,
  actions: actions,
  getters: getters
}
export * from './search-types.store';


// WEBPACK FOOTER //
// ./src/store/search/index.ts